var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDumbbell = function SvgDumbbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02001 5.42753C8.62948 5.03701 8.62948 4.40384 9.02001 4.01332L11.6831 1.35022C12.0736 0.959698 12.7068 0.959698 13.0973 1.35022L18.2068 6.4597C18.5973 6.85023 18.5973 7.48339 18.2068 7.87392L15.5437 10.537C15.1532 10.9275 14.52 10.9275 14.1295 10.537L12.3904 8.79794L9.12858 12.0598L10.8685 13.7997C11.259 14.1902 11.259 14.8234 10.8685 15.2139L8.2054 17.877C7.81488 18.2675 7.18171 18.2675 6.79119 17.877L1.68171 12.7675C1.29119 12.377 1.29119 11.7438 1.68171 11.3533L4.34481 8.69022C4.73533 8.29969 5.36849 8.29969 5.75902 8.69022L7.49766 10.4289L10.7595 7.16702L9.02001 5.42753Z",
    fill: "#FFA826"
  })));
};

export default __webpack_public_path__ + "static/media/dumbbell.89928ab4.svg";
export { SvgDumbbell as ReactComponent };